<template>
  <div class="relative min-h-screen w-full" v-on:mouseleave="mouseleave">
    <!-- <div class="fixed top-4 left-4">
      {{ currentStepNumber }}
    </div> -->
    <div
      class="absolute inset-0 bg-gray-100 hidden sm:flex sm:flex-col md:hidden justify-center items-center z-50"
    >
      <img
        class="mx-auto w-40 h-40 p-4 bg-red-600 rounded-full"
        :src="getUrl('wp-content/uploads/2021/09/rotate.gif')"
      />
      <p class="mt-4">Per favore ruota il dispositivo per procedere, grazie.</p>
    </div>
    <div class="md:h-screen pb-14" v-show="!showLoader">
      <div class="grid grid-cols-12 h-full w-full">
        <div
          id="main-box"
          class="flex flex-col px-3 md:px-6 pt-8 pb-20 w-full text-center overflow-y-auto h-full relative justify-start col-span-12 md:col-span-8 bg-[#f6f4f0]"
        >
          <div ref="main-template" id="position-pix" class="h-1 w-1 opacity-0">
            &nbsp;
          </div>

          <a target="_blank" class="block mx-auto" href="https://realbowl.it/">
            <svg
              id="logo-realbowl"
              class="h-16 w-auto fill-current text-red-600"
              viewBox="0 0 310 316"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M98.51 31.7897C98.51 31.7897 88.0784 0 81.1161 0C74.1539 0 73.4229 11.2323 73.4229 27.8648C86.4409 27.2615 98.5108 31.7897 98.5108 31.7897H98.51ZM124.773 121.185C124.461 122.973 124.303 124.784 124.301 126.599V153.337C124.301 172.374 141.11 187.487 159.827 187.487C177.53 187.487 195.209 176.733 195.209 160.603C195.281 158.189 194.938 155.78 194.193 153.482H166.215V153.919C166.212 154.782 166.035 155.636 165.694 156.429C165.354 157.223 164.857 157.939 164.234 158.536C163.611 159.133 162.874 159.597 162.068 159.903C161.261 160.208 160.402 160.347 159.54 160.312C158.682 160.335 157.827 160.187 157.026 159.877C156.225 159.568 155.494 159.102 154.873 158.508C154.253 157.913 153.756 157.202 153.411 156.414C153.067 155.627 152.881 154.778 152.866 153.919V147.089H195.212V126.599C195.212 107.855 178.693 92.4499 159.976 92.4499C157.422 92.4543 154.877 92.7353 152.384 93.2878C147.586 104.303 139.043 115.156 124.775 121.185H124.773ZM152.866 126.309C152.921 124.49 153.677 122.763 154.975 121.49C156.273 120.217 158.013 119.497 159.83 119.479C160.71 119.484 161.581 119.666 162.39 120.015C163.2 120.363 163.931 120.871 164.54 121.508C165.149 122.145 165.624 122.899 165.937 123.723C166.25 124.548 166.393 125.427 166.36 126.309V133.43H152.863L152.866 126.309ZM164.249 227.288C137.142 210.444 109.071 229.465 109.071 254.909V280.956C109.071 299.653 123.721 315.513 142.385 315.934C161.619 316.367 176.832 300.797 176.832 281.793V250.059C176.84 245.505 175.689 241.025 173.487 237.04C171.285 233.056 168.106 229.7 164.249 227.288ZM149.695 281.647C149.696 282.545 149.52 283.433 149.178 284.262C148.836 285.091 148.333 285.845 147.7 286.479C147.066 287.114 146.314 287.617 145.487 287.96C144.659 288.303 143.771 288.479 142.876 288.478C141.074 288.455 139.352 287.728 138.078 286.452C136.804 285.176 136.078 283.452 136.056 281.647V254.62C136.086 252.793 136.834 251.051 138.138 249.773C139.441 248.495 141.195 247.782 143.02 247.789C144.806 247.818 146.509 248.551 147.759 249.83C149.009 251.109 149.705 252.83 149.695 254.62V281.647ZM286.502 40.4846C276.865 40.4846 283.006 61.9101 283.006 101.435V181.297C283.006 182.592 283.52 183.835 284.435 184.751C285.35 185.667 286.591 186.182 287.885 186.182H305.122C306.415 186.182 307.656 185.667 308.571 184.751C309.486 183.835 310 182.592 310 181.297V101.435C310 66.729 296.145 40.4846 286.509 40.4846H286.502ZM233.945 133.72C222.481 134.737 203.207 141.568 203.207 160.604C203.063 179.205 220.742 187.633 231.914 187.633C243.958 187.633 249.326 181.966 251.794 178.478L255.313 182.004C257.983 184.677 261.603 186.179 265.378 186.18H272.393V126.744C272.43 122.255 271.578 117.803 269.888 113.645C268.198 109.486 265.703 105.704 262.547 102.516C259.391 99.3282 255.636 96.7974 251.498 95.0697C247.361 93.3421 242.923 92.4517 238.44 92.4499C220.738 92.4499 204.631 103.204 204.631 119.333C204.654 121.885 204.996 124.424 205.647 126.891H231.909C231.909 125.098 232.62 123.379 233.886 122.112C235.151 120.844 236.868 120.132 238.658 120.132C240.448 120.132 242.164 120.844 243.43 122.112C244.695 123.379 245.406 125.098 245.406 126.891C245.406 130.962 242.068 133.139 233.942 133.72H233.945ZM245.26 143.892V153.483C245.232 155.272 244.5 156.978 243.223 158.23C241.946 159.482 240.227 160.179 238.44 160.168C237.559 160.183 236.685 160.02 235.868 159.689C235.052 159.358 234.31 158.866 233.688 158.243C233.065 157.619 232.574 156.876 232.244 156.058C231.913 155.241 231.751 154.365 231.765 153.483C231.765 148.978 235.247 147.527 238.585 146.654C241.197 146.072 244.824 145.055 245.26 143.892ZM1.98312 67.5938C-2.67654 71.7133 10.2577 79.1062 26.0433 77.9206C15.7987 68.3389 6.6436 63.4752 1.98312 67.5938ZM272.461 222.503H255.824C254.632 222.504 253.481 222.941 252.589 223.734C251.697 224.526 251.125 225.618 250.982 226.804L246.422 264.79L241.858 226.804C241.715 225.618 241.144 224.526 240.252 223.734C239.36 222.942 238.209 222.504 237.017 222.503H218.373C217.184 222.504 216.036 222.94 215.144 223.728C214.253 224.517 213.681 225.605 213.534 226.787L208.84 264.791L204.277 226.805C204.134 225.619 203.562 224.527 202.671 223.735C201.779 222.943 200.628 222.505 199.436 222.504H182.8C182.074 222.504 181.356 222.667 180.7 222.981C180.045 223.294 179.467 223.75 179.01 224.316C178.553 224.882 178.227 225.542 178.058 226.25C177.888 226.958 177.879 227.694 178.03 228.406L195.539 310.625C195.772 311.719 196.373 312.699 197.24 313.402C198.108 314.106 199.191 314.49 200.307 314.49H219.339C220.555 314.49 221.726 314.035 222.624 313.215C223.522 312.395 224.083 311.268 224.195 310.056L227.703 272.058L231.079 310.039C231.188 311.254 231.747 312.385 232.646 313.209C233.545 314.032 234.719 314.489 235.937 314.489H254.952C256.069 314.489 257.151 314.105 258.019 313.401C258.887 312.698 259.488 311.718 259.721 310.625L277.231 228.405C277.382 227.694 277.373 226.957 277.203 226.249C277.034 225.542 276.708 224.881 276.251 224.315C275.794 223.75 275.216 223.293 274.561 222.98C273.905 222.666 273.188 222.504 272.461 222.503ZM305.117 198.238H287.88C286.586 198.238 285.345 198.752 284.43 199.669C283.515 200.585 283.001 201.828 283.001 203.123V309.606C283.001 310.902 283.515 312.144 284.43 313.061C285.345 313.977 286.586 314.492 287.88 314.492H305.117C306.411 314.492 307.651 313.977 308.566 313.061C309.481 312.144 309.995 310.902 309.995 309.606V203.119C309.995 201.824 309.481 200.581 308.566 199.665C307.651 198.748 306.411 198.234 305.117 198.234V198.238ZM103.593 230.724C103.554 212.717 88.7524 198.234 70.7723 198.234H39.4044C38.1105 198.234 36.8697 198.748 35.9548 199.665C35.0399 200.581 34.526 201.824 34.526 203.119V309.606C34.526 310.902 35.0399 312.144 35.9548 313.061C36.8697 313.977 38.1105 314.492 39.4044 314.492H71.1081C88.924 314.492 103.585 300.123 103.593 282.279C103.601 266.112 99.3938 261.019 91.8421 256.655C99.4174 252.132 103.631 247.022 103.593 230.732V230.724ZM76.6077 279.757C76.578 281.766 75.7781 283.686 74.3738 285.119C72.9695 286.553 71.0684 287.391 69.0641 287.46H61.5173V265.372H69.0641C71.0684 265.441 72.9695 266.279 74.3738 267.713C75.7781 269.147 76.578 271.066 76.6077 273.075V279.757ZM76.6077 239.505C76.578 241.513 75.7781 243.433 74.3738 244.867C72.9695 246.301 71.0684 247.139 69.0641 247.207H61.5173V225.265H69.0641C71.0536 225.3 72.9516 226.107 74.3587 227.517C75.7657 228.926 76.572 230.826 76.6077 232.819V239.505ZM3.31492 35.4776C-5.90034 37.0834 4.87193 56.7687 26.0465 67.7005C20.4364 47.3287 12.5302 33.871 3.31492 35.4776ZM40.7654 186.382H64.8524C66.5001 186.382 68.0803 185.726 69.2454 184.559C70.4105 183.393 71.065 181.81 71.065 180.16V135.631L86.3644 182.108C86.7739 183.352 87.5646 184.434 88.624 185.202C89.6834 185.969 90.9575 186.382 92.2649 186.382H114.075C115.062 186.382 116.034 186.147 116.913 185.698C117.791 185.249 118.551 184.597 119.129 183.796C119.708 182.996 120.088 182.07 120.24 181.093C120.391 180.117 120.309 179.119 120.001 178.18L103.02 126.522C78.7046 126.522 67.7795 121.995 58.4 110.747C46.078 95.9708 53.237 66.4766 72.5416 66.4766C72.5416 88.5364 92.7722 110.367 108.566 110.09C109.166 110.138 109.771 110.102 110.361 109.984C110.452 109.965 110.534 109.942 110.623 109.922C111.539 109.797 112.44 109.584 113.316 109.287C143.656 101.307 142.739 67.7265 142.739 67.7265C132.907 66.5051 124.156 64.6852 110.83 51.6713C106.721 47.2542 101.749 43.7312 96.2227 41.3217C90.6962 38.9122 84.7337 37.6676 78.7062 37.6656C75.9203 37.6709 73.1375 37.8504 70.3739 38.203C60.3684 10.615 50.849 0.00325535 44.5787 0.00325535C36.5643 0.00325535 34.5284 14.7671 34.5284 51.7747V180.135C34.5284 181.792 35.1857 183.381 36.3557 184.553C37.5256 185.724 39.1125 186.383 40.7671 186.383L40.7654 186.382ZM61.74 97.224C65.4322 106.879 74.249 113.341 86.0612 113.341C74.5206 108.293 66.9428 91.6975 66.629 82.1606C61.6335 81.3039 58.3829 88.4476 61.7384 97.2248"
                fill="currentColor"
              />
            </svg>
          </a>
          <div class="mt-8 font-normal text-sm">
            Step {{ currentStepNumber }}/{{ this.length }}
          </div>
          <div
            class="progress-bar h-3 mx-auto max-w-md w-full bg-white rounded-xl relative overflow-hidden mt-2 flex-shrink-0 flex"
          >
            <div
              class="progress bg-red-600 rounded-xl w-full"
              :style="`max-width: ${progress}%;`"
            >
              &nbsp;
            </div>
          </div>

          <keep-alive>
            <component
              class="mx-auto w-full mt-10"
              ref="currentStep"
              :is="currentStep"
              @updateAsyncState="updateAsyncState"
              :wizard-data="form"
              :dog-data="dog"
              :list-data="lists"
              @actionButtonEnabled="enableActionButton"
            ></component>
          </keep-alive>

          <div class="mx-auto w-full max-w-xs pt-4" v-if="currentStepNumber == 5">
            <label class="flex justify-center">
              <input
                type="checkbox"
                id="checked"
                class="privacy-check"
                v-model="privacy"
              />
              <div class="ml-2 text-sm leading-snug">
                Dichiaro di essere maggiorenne e di aver letto ed accettato la
                <a
                  class="text-red-600 underline"
                  :href="getUrl('privacy-policy/')"
                  target="_blank"
                  >privacy policy</a
                >
                e le
                <a
                  class="text-red-600 underline"
                  :href="getUrl('termini-e-condizioni/')"
                  target="_blank"
                  >condizioni generali di servizio</a
                >
              </div>
            </label>
          </div>

          <!-- Actions -->
          <div class="buttons mx-auto w-full max-w-xl mt-12 flex flex-col">
            <button
              :id="'v3_next-btn-step' + currentStepNumber"
              @click="nextButtonAction"
              class="btn-main"
              :class="[actionButtonEnabled && privacyChecked ? '' : 'disabled']"
              :disabled="!actionButtonEnabled && !privacyChecked"
            >
              <!-- <div
                class="flex justify-center gap-4"
              >
                <svg
                  class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  ></circle>
                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
              </div> -->
              <div>
                {{ nextStepButtonMessage }}
              </div>
            </button>
            <button
              :id="'v3_back-btn-step' + currentStepNumber"
              @click="goBack"
              v-if="currentStepNumber > 1"
              class="px-4 py-2 text-red-600 underline text-sm focus:ring-0 focus:outline-none mt-4 inline-block mx-auto"
            >
              Torna indietro
            </button>
          </div>
        </div>
        <div
          class="col-span-12 md:col-span-4 items-center justify-center illustration-container"
        >
          <StepIllustration
            :desktopIllustration="getImageUrl(currentDesktopIllustration)"
            :mobileIllustration="getImageUrl(currentMobileIllustration)"
            :currentStep="currentStepNumber"
          ></StepIllustration>
        </div>
      </div>
    </div>

    <div class="loading-wrapper end-message" v-show="showLoader">
      <div class="loader mx-auto max-w-2xl">
        <img
          class="mx-auto rounded-full h-auto w-72"
          :src="getUrl('wp-content/uploads/2021/09/nonna_ragu.gif')"
          alt=""
        />
        <h1 class="title mt-8" v-if="rbAction == 'rb_add_to_cart'">
          Stiamo preparando la pappa su misura per
          <span v-if="form.numberOfDogs > 1">
            i tuoi {{ form.numberOfDogs }} amici a quattro zampe
          </span>
          <span v-else>
            {{ dog.sex == 2 ? "la tua" : "il tuo" }} {{ dog.name | capitalize }}
          </span>
        </h1>
        <h1 v-else-if="rbAction == 'rb_send_email_user_type'">
          Stiamo registrando il tuo contatto, verrai ricontattato il prima possibile per
          una proposta su misura!
        </h1>
        <h1 v-else-if="rbAction == 'rb_send_email_dog_not_healthy'">
          Stiamo verificando le disponibilità dei nostri nutrizionisti, verrai
          ricontattato il prima possibile con una proposta di appuntamento!
        </h1>
        <h1 v-else></h1>
      </div>
    </div>
  </div>
</template>

<script>
import Form01DogInfo01 from "./Form01DogInfo01";
import Form02DogInfo02 from "./Form02DogInfo02";
import Form03FoodInfo01 from "./Form03FoodInfo01";
import Form04UserInfo01 from "./Form04UserInfo01";
import Form05UserInfo02 from "./Form05UserInfo02";

import snakecaseKeys from "snakecase-keys";
import camelcaseKeys from "camelcase-keys";

import axios from "axios";
import StepIllustration from "./StepIllustration";

export default {
  name: "FormWizard",
  components: {
    StepIllustration,
    Form01DogInfo01,
    Form02DogInfo02,
    Form03FoodInfo01,
    Form04UserInfo01,
    Form05UserInfo02,
  },
  data() {
    return {
      pluginNumber: "3",
      couponAttempts: 0,
      debug: process.env.NODE_ENV == "development",
      privacy: false,
      // illustration: "",
      desktopIllustration: "",
      mobileIllustration: "",
      currentStepNumber: 1,
      asyncState: null,
      sendinblueApiKey: null,
      actionButtonEnabled: true,
      rbAction: "",
      helpOpen: false,
      steps: [
        "Form01DogInfo01",
        "Form02DogInfo02",
        "Form03FoodInfo01",
        "Form04UserInfo01",
        "Form05UserInfo02",
      ],
      illustrations: {
        desktop: [
          "questionario_01.jpg",
          "questionario_02.jpg",
          "questionario_03.gif",
          "questionario_04.jpg",
          "questionario_05.gif",
        ],
        mobile: [
          "questionario_01.jpg",
          "questionario_02.jpg",
          "questionario_03.gif",
          "questionario_04.jpg",
          "questionario_05.gif",
        ],
      },
      form: {
        userType: 1,
        name: null,
        email: null,
        postcode: null,
        isRemoteArea: 0,
        phoneNumber: null,
        numberOfDogs: null,
        indexDog: 0,
        dogs: [],
        sameDiet: 1,
        foodPreparationMethodId: null,
        subscriptionPeriodInDays: 28,
        knownThrough: null,
        couponCode: "",
        couponDiscount: null,
        couponCodeDefault: "",
        couponDiscountDefault: null,
      },
      dog: {},
      lists: {
        breeds: [],
        foodPreparationMethods: [],
        recipes: [],
        howDidYouKnowUs: [],
      },
    };
  },
  watch: {
    "form.numberOfDogs": function (value) {
      if (value && this.currentStepNumber == 2) {
        this.form.dogs = [];
        for (let i = 0; i < value; i++) {
          this.$set(this.form.dogs, i, this.initialState());
        }
      }
    },
    "form.indexDog": function () {
      Object.assign(this.dog, this.form.dogs[this.form.indexDog]);
    },
  },
  computed: {
    isCouponStep() {
      return this.currentStepNumber === 4;
    },
    isLastStep() {
      return this.currentStepNumber === this.length && !this.goNextDogWithDifferentDiet;
    },
    showLoader() {
      return this.asyncState === "pending";
    },
    length() {
      return this.steps.length;
    },
    currentStep() {
      return this.steps[this.currentStepNumber - 1];
    },
    progress() {
      return (this.currentStepNumber / this.length) * 100;
    },
    privacyChecked() {
      return this.isLastStep ? this.privacy == true : true;
    },
    currentDesktopIllustration() {
      return this.illustrations.desktop[this.currentStepNumber - 1];
    },
    currentMobileIllustration() {
      return this.illustrations.mobile[this.currentStepNumber - 1];
    },
    nextStepButtonMessage() {
      return this.isLastStep
        ? "Vai al Checkout"
        : this.goNextDogWithSameDiet || this.goNextDogWithDifferentDiet
        ? "Vai al prossimo peloso"
        : "Prosegui";
    },
    dogsWithSameDiet() {
      return this.form.numberOfDogs >= 2 && this.form.sameDiet == 1;
    },
    goNextDogWithSameDiet() {
      return (
        this.dogsWithSameDiet &&
        this.currentStepNumber == 2 &&
        this.form.indexDog + 1 < this.form.numberOfDogs
      );
    },
    goBackDogWithSameDiet() {
      return (
        (this.dogsWithSameDiet || this.dogsWithDifferentDiet) &&
        this.currentStepNumber == 2 &&
        this.form.indexDog + 1 <= this.form.numberOfDogs &&
        this.form.indexDog > 0
      );
    },
    dogsWithDifferentDiet() {
      return this.form.numberOfDogs >= 2 && this.form.sameDiet == 0;
    },
    goNextDogWithDifferentDiet() {
      return (
        this.dogsWithDifferentDiet &&
        this.currentStepNumber == 3 &&
        this.form.indexDog + 1 < this.form.numberOfDogs
      );
    },
  },
  methods: {
    scrollFunnelToTop() {
      // To scroll to top needs to use $nextTick.
      // DOM is not updated yet.
      this.$nextTick(function () {
        // DOM is now updated.
        // `this` is bound to the current instance.
        this.$refs["main-template"].scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
      });
    },
    getUrl(value) {
      return this.$hostname + "/" + value;
    },
    getImageUrl(value) {
      return this.getUrl("wp-content/uploads/2023/09/" + value);
    },
    mouseleave() {
      // Opens video popup when mouse leave
      // var stepWithVideoPopup = [6, 9, 10];
      // if (stepWithVideoPopup.includes(this.currentStepNumber)) {
      //   this.$refs.currentStep.openModal();
      // }
    },
    enableActionButton(value) {
      this.actionButtonEnabled = value;
    },
    updateAsyncState(state) {
      this.asyncState = state;
    },
    updateDogsWithSameDiet(dog) {
      if (this.dogsWithSameDiet) {
        if (
          "isFullMeal" in dog ||
          "recipeId" in dog ||
          "isDoubleTaste" in dog ||
          "oilSlug" in dog ||
          "extraIngredientIds" in dog ||
          "seasonalVegetables" in dog ||
          "isDuplex" in dog
        ) {
          for (let i = 0; i < this.form.numberOfDogs; i++) {
            for (const key in dog) {
              this.$set(this.form.dogs[i], key, dog[key]);
            }
          }
        }
      }
    },
    submitOrder() {
      this.updateAsyncState("pending");
      const url = this.$hostname + "/checkout";
      const config = {
        headers: { "Content-Type": "application/json" },
      };
      let data = JSON.stringify(
        snakecaseKeys({ form: this.form, rbAction: this.rbAction })
      );
      this.saveToLocalStorage();

      axios
        .post(url, data, config)
        .then(function () {
          window.location = "/" + "checkout";
        })
        .catch(function (error) {
          if (this.debug) console.log(error);
        });
    },
    initialState() {
      // initiated
      return {
        name: null,
        dogId: null,
        breedId: null,
        breedIdFather: null,
        breedIdMother: null,
        sex: 0, // undefined.
        neutering: 1.0, // not neutered.
        hasBirthDate: 0, // has not birth date.
        birthDate: "",
        months: null,
        adult: null,
        healthy: 1, // is healthy.
        disease: "",
        weight: null,
        activityLevel: 100, // normal.
        bodyConditionScoreSystem: 1.0, // ideal.
        recipeId: null,
        extraIngredientIds: [],
        allergyIds: [],
        otherFoodAllergies: null,
        oilSlug: 1, // with oil.
        isFullMeal: 1, // full meal.
        isDoubleTaste: null,
        seasonalVegetables: 0, // not seasonal vegetables.
        isDuplex: 0, // not duplex.
      };
    },
    nextButtonAction() {
      this.$refs.currentStep
        .submit()
        .then((stepData) => {
          var dogCopy = [];
          Object.assign(this.dog, stepData.dog);
          Object.assign(this.form, stepData.form);
          dogCopy = Object.assign({}, this.dog);
          this.$set(this.form.dogs, this.form.indexDog, dogCopy);
          this.rbAction = "";

          if ("dog" in stepData) {
            this.updateDogsWithSameDiet(stepData.dog);
          }

          if (!this.isLastStep) {
            this.sendaDataToGoogleTagManager("funnelStepCompleted");
          } else {
            this.sendaDataToGoogleTagManager("funnelLead");
          }

          if (this.isCouponStep && this.couponAttempts < 2) {
            this.fetchCoupon();
          } else if (this.isLastStep) {
            this.sendDataToSendinBlue();
            this.sendDataToHubspot();
            this.sendaDataToGoogleTagManager("funnelToCheckout");

            this.rbAction = "rb_add_to_cart";
            this.submitOrder();
          } else if (this.goNextDogWithSameDiet || this.goNextDogWithDifferentDiet) {
            this.goNextDog();
          } else {
            // if (this.currentStepNumber == 1) {
            // this.sendDataToSendinBlue();
            // }
            this.goNext();
          }
        })
        .catch((error) => {
          if (this.debug) console.log(error);
        });
      this.scrollFunnelToTop();
    },
    saveToLocalStorage() {
      localStorage.setItem("RBStoredData", JSON.stringify(this.form));
      localStorage.setItem("RBCurrentStepNumber", JSON.stringify(this.currentStepNumber));
      localStorage.setItem("RBFormWizard", JSON.stringify(this.pluginNumber));
    },
    removeFromLocalStorage() {
      localStorage.removeItem("RBStoredData");
      localStorage.removeItem("RBCurrentStepNumber");
      localStorage.removeItem("RBFormWizard");
    },
    fetchCoupon() {
      if (this.form.couponCode === null) {
        this.couponAttempts = 0;
        this.goNext();
      } else {
        this.$refs.currentStep.loaderAsyncState("pending");

        let data = new FormData();
        data.append("action", "coupon_exists");
        data.append("coupon", this.form.couponCode);

        axios
          .post(rb_sbt.ajaxurl, data)
          .then((response) => {
            let res = response.data;
            if (res.success == false) {
              this.couponAttempts++;
              if (this.couponAttempts == 1) {
                this.$refs.currentStep.setErrorMessage(
                  "Ops! Prova a scrivere di nuovo il suo codice."
                );
              } else if (this.couponAttempts == 2) {
                this.$refs.currentStep.setErrorMessage(
                  "Questo codice non risulta disponibile, non ti preoccupare clicca su prosegui e avrai un sconto sul tuo acquisto."
                );
              }
              this.form.couponDiscount = null;
              this.form.couponDiscount = null;
            } else {
              this.form.couponDiscount = res.data.discount;
              this.goNext();
            }
            this.$refs.currentStep.loaderAsyncState("success");
          })
          .catch((error) => {
            if (this.debug) console.log(error);
          });
      }
    },
    goBack() {
      if (this.isLastStep) {
        this.couponAttempts = 0;
      }
      if (this.actionButtonEnabled) this.actionButtonEnabled = true;
      this.saveToLocalStorage();
      if (this.goBackDogWithSameDiet) {
        this.goBackDog();
      } else {
        this.currentStepNumber--;
      }

      this.scrollFunnelToTop();
    },
    goBackDog() {
      this.currentStepNumber = 2;
      if (this.dogsWithSameDiet) {
        this.currentStepNumber = 2;
      }
      this.form.indexDog--;
    },
    goNext() {
      this.saveToLocalStorage();
      this.currentStepNumber++;
    },
    goNextDog() {
      this.currentStepNumber = 1;
      this.form.indexDog++;
      this.goNext();
    },
    sendDataToSendinBlue() {
      const url = this.$restAPIurlRB + "sb";
      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const today = new Date();
      const urlParams = new URLSearchParams(window.location.search);

      const formSendingBlue = Object.assign({}, this.form);
      formSendingBlue.funnelID = this.pluginNumber;
      formSendingBlue.funnelStartDate =
        ("00" + today.getUTCDate()).slice(-2) +
        "-" +
        ("00" + (today.getUTCMonth() + 1)).slice(-2) +
        "-" +
        today.getUTCFullYear(); //gg-mm-aaaa;
      formSendingBlue.status = "Attivo";
      formSendingBlue.utmSource = urlParams.get("utm_source");
      formSendingBlue.utmMedium = urlParams.get("utm_medium");
      formSendingBlue.utmCampaign = urlParams.get("utm_campaign");
      formSendingBlue.utmContent = urlParams.get("utm_content");
      formSendingBlue.utmTerm = urlParams.get("utm_term");

      let data = JSON.stringify(
        snakecaseKeys({
          form: formSendingBlue,
          rbAction: "rb_sb",
          currentStepNumber: this.currentStepNumber,
          nonce: window.WP_API_Settings.nonce,
        })
      );

      axios
        .post(url, data, config)
        .then((response) => {
          // this.rbAction = "";
          if (this.debug) console.log(response);
        })
        .catch((error) => {
          if (this.debug) console.log(error);
        });
    },
    sendDataToHubspot() {
      const url = this.$restAPIurlRB + "hs";
      const config = {
        headers: { "Content-Type": "application/json" },
      };
      const formData = Object.assign({}, this.form);

      let data = JSON.stringify(
        snakecaseKeys({
          form: formData,
          rbAction: "rb_hs",
          nonce: window.WP_API_Settings.nonce,
        })
      );

      axios
        .post(url, data, config)
        .then((response) => {
          if (this.debug) console.log(response);
        })
        .catch((error) => {
          if (this.debug) console.log(error);
        });
    },
    sendaDataToGoogleTagManager(eventValue) {
      let data = {
        event: eventValue,
        funnel: {
          stepID: this.pluginNumber,
          stepCount: 5,
        },
      };
      if (eventValue == "funnelStepCompleted" || eventValue == "funnelLead") {
        data.funnel.currentStep = this.currentStepNumber.toString();
      }
      this.$nextTick(function () {
        window.dataLayer.push(data);
      });
    },
    async fetchLists() {
      // Must be with promise, otherwise some lists will remain empty
      this.enableActionButton(false);
      // fetch uset types, breeds, foodPreparationMethods
      const [breeds, foodPreparationMethods, recipes] = await Promise.all([
        fetch(this.$restAPIurlRB + "breeds"),
        fetch(
          this.$restAPIurlWP + "food-preparation-method?_fields=id,name&per_page=100"
        ),
        fetch(
          this.$restAPIurlWP +
            "recipe?_fields=id,title,food-preparation-method,ingredient,toolset-meta.recipes-details.recipe-main-ingredient-icon,toolset-meta.ingredient"
        ),
      ]);

      this.lists.breeds = await breeds.json();
      this.lists.foodPreparationMethods = await foodPreparationMethods.json();
      this.lists.recipes = camelcaseKeys(await recipes.json(), {
        deep: true,
      });

      this.lists.howDidYouKnowUs = [
        {
          id: 0,
          name: "Tramite Internet (Facebook, Instagram, ...)",
        },
        {
          id: 1,
          name: "Tramite un Professionista (Allevatore, Veterinario, ...)",
        },
        { id: 2, name: "Altro" },
      ];

      // Fetch coupon code.
      let data = new FormData();
      data.append("action", "coupon_default");

      axios
        .post(rb_sbt.ajaxurl, data)
        .then((response) => {
          let res = response.data;
          if (res.success == true) {
            this.form.couponCodeDefault = res.data.couponCode;
            this.form.couponDiscountDefault = res.data.discount;
          }
        })
        .catch((error) => {
          if (this.debug) console.log(error);
        });

      this.enableActionButton(true);
    },
  },
  async created() {
    this.updateAsyncState("");

    // Must be async/await, otherwise some lists will remain empty
    await this.fetchLists();

    // Then get data from local storage
    var RBLastclear = localStorage.getItem("RBLastclear"),
      time_now = new Date().getTime();

    // .getTime() returns milliseconds so 1000 * 60 * 60 * 24 = 24 h
    if (time_now - RBLastclear > 1000 * 60 * 60 * 24 * 7) {
      this.removeFromLocalStorage();
      // localStorage.clear();
      localStorage.setItem("RBLastclear", time_now);
    }

    var RBStoredData = JSON.parse(localStorage.getItem("RBStoredData"));
    var RBCurrentStepNumber = JSON.parse(localStorage.getItem("RBCurrentStepNumber"));
    var RBFormWizard = parseInt(JSON.parse(localStorage.getItem("RBFormWizard")));

    if (RBStoredData && RBCurrentStepNumber > 1 && RBFormWizard) {
      // this.privacy = true;
      if (RBFormWizard == parseInt(this.pluginNumber)) {
        Object.assign(this.dog, RBStoredData.dogs[RBStoredData.indexDog]);
        Object.assign(this.form, RBStoredData);
        this.currentStepNumber = RBCurrentStepNumber;
        if (RBCurrentStepNumber > this.length) {
          this.currentStepNumber = this.length;
        }
      } else {
        this.dog = this.initialState();
      }
    } else {
      this.dog = this.initialState();
    }
    // Set food preparation method.
    const foodPreparationMethod = this.lists.foodPreparationMethods.filter(
      (method) => method.name == "Cotto"
    );
    this.form.foodPreparationMethodId = foodPreparationMethod[0].id;

    if (this.currentStepNumber == 1) {
      this.sendaDataToGoogleTagManager("funnelStart");
    }
  },
};
</script>

<style>
@font-face {
  font-family: "GoodMood";
  font-display: swap;
  src: url("../assets/font/GoodMoodRevised.otf") format("opentype");
}

#rb-app3 div:empty {
  @apply hidden;
}
#rb-app3 .loading-wrapper {
  @apply bg-[#f6f4f0] flex items-center justify-center text-center z-30;
}
#rb-app3 .end-message {
  @apply h-screen;
}
#rb-app3 .illustration-container {
  background-image: url("../assets/images/sfondo_pappe.jpg");
  background-size: cover;
  background-position: center;
}
#rb-app3 .progress {
  @apply absolute bg-red-600 h-full left-0 top-0 transition-all ease-in-out duration-200;
}
#rb-app3 .title {
  @apply text-4xl;
}
#rb-app3 .subtitle {
  @apply text-xl md:leading-tight leading-7;
}
#rb-app3 .form-group {
  @apply mt-5 text-left;
}
#rb-app3 .form-label {
  @apply text-base font-semibold text-gray-800;
}
#rb-app3 .important-label {
  /*  @apply block text-4xl leading-7 text-red-600 font-normal rb-subtitle-font; */
  @apply block leading-7 text-gray-800 font-normal;
}
#rb-app3 .error {
  @apply mt-2 text-sm text-red-800;
}
#rb-app3 .form-control {
  @apply shadow-sm border-solid border border-gray-500 focus:border-gray-800 focus:bg-gray-100 block w-full sm:text-lg focus:ring-0 focus:outline-none placeholder-gray-500 text-left appearance-none py-2 px-2 rounded-lg;
}
#rb-app3 .privacy-check {
  @apply appearance-none checked:border-transparent checked:bg-red-600 focus:ring-2 focus:ring-red-300 focus:outline-none !important;
}
#rb-app3 input::-webkit-outer-spin-button,
#rb-app3 input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
#rb-app3 [type="number"].form-control {
  -moz-appearance: textfield;
}
#rb-app3 textarea.form-control {
  @apply h-16;
}
#rb-app3 .switch-container {
  /* @apply mt-2.5 flex rounded-full border-solid border-3 border-red-600 overflow-hidden md:w-1/2 mx-auto w-11/12; */
  @apply mt-2.5 flex gap-4 overflow-hidden;
}
#rb-app3 .switch-container.big {
  @apply md:w-10/12 mx-auto w-11/12;
}
#rb-app3 .switch-container.small {
  @apply mt-2.5 mx-auto max-w-sm w-full;
}

/*.illustration-container
  #rb-app3 .switch-empty {
    @apply divide-x-3 divide-red-600;
  }
  #rb-app3 .switch-empty .switch-option {
    @apply border-solid;
  }*/

#rb-app3 .switch-option {
  @apply p-2 text-center w-1/2 text-lg flex items-center justify-center leading-tight font-semibold cursor-pointer transition-colors duration-200 ease-in-out rounded-lg border-red-600 border border-solid;
}
#rb-app3 .small .switch-option {
  @apply p-2 text-center w-1/2 text-sm flex items-center justify-center leading-tight font-semibold cursor-pointer transition-colors duration-200 ease-in-out;
}
#rb-app3 .active-option {
  @apply bg-red-600 text-white;
}
#rb-app3 .inactive-option {
  @apply bg-white text-red-600;
}
#rb-app3 .big-active-option,
#rb-app3 .big-inactive-option {
  @apply cursor-pointer border-gray-300 transition-colors duration-200 ease-in-out;
}
#rb-app3 .big-active-option {
  @apply border-red-600;
}
#rb-app3 .option-btn {
  @apply inline-block mx-auto px-14 text-4xl mt-4 border-2 border-solid leading-7 rounded-3xl transition-colors duration-200 ease-in-out;
}
#rb-app3 .big-active-option .option-btn {
  @apply bg-red-600 text-white border-red-600;
}
#rb-app3 .big-inactive-option .option-btn {
  @apply bg-white text-gray-400 border-gray-400;
}
#rb-app3 .additional-info {
  @apply text-base text-gray-500 mt-3 leading-5 text-left;
}
#rb-app3 .btn-main {
  @apply w-full focus:ring-0 focus:outline-none transition-colors max-w-xs mx-auto text-center bg-red-600 text-white text-lg px-4 py-2 rounded-lg font-semibold;
}
#rb-app3 .btn-main.disabled {
  @apply cursor-not-allowed border-gray-400 text-gray-500 hover:border-gray-400 hover:bg-gray-50 hover:text-gray-500 bg-gray-50 !important;
}
#rb-app3 .options-container {
  @apply flex flex-wrap justify-center space-x-2;
}
#rb-app3 .option-tag {
  @apply border-solid border-3 rounded-xl px-4 py-1 text-lg uppercase font-semibold mt-2 cursor-pointer transition-colors;
}
#rb-app3 .option-tag.unchecked {
  @apply border-gray-400 text-gray-400;
}
#rb-app3 .option-tag.checked {
  @apply border-red-600 text-red-600;
}
#rb-app3 .option-tag span {
  @apply whitespace-nowrap;
}
#rb-app3 .option-radio {
  @apply flex flex-col border-gray-300 p-4 rounded-xl border-solid border-3 items-start transition-colors cursor-pointer;
}
#rb-app3 .option-radio.option-icon {
  @apply flex-row justify-between items-center px-3 py-2;
}
#rb-app3 .option-radio.checked {
  @apply border-red-600 text-red-600;
}
#rb-app3 .option-label {
  @apply font-semibold transition-colors;
}
#rb-app3 .option-detail {
  @apply text-gray-400 text-sm;
}
#rb-app3 .rb_recipe-title {
  @apply mx-auto pb-2 text-red-600 rb-subtitle-font text-3xl;
}

#rb-app3 .rb_recipe-description {
  line-height: 1.2em;
  max-width: 90%;
  min-height: 4.25em;
  @apply mx-auto;
}

#rb-app3 .step-number {
  @apply rounded-full bg-red-600 text-white w-24 h-24 flex items-center justify-center text-7xl mx-auto mb-4 rb-subtitle-font;
}

#rb-app3 .step-disc-container {
  @apply flex justify-between list-none transform max-w-4xl mx-auto w-full p-0 rb-subtitle-font -translate-y-4;
}
#rb-app3 .step-disc {
  @apply text-2xl md:text-4xl md:leading-7 leading-4 rounded-full h-5 w-5 md:h-8 md:w-8 block border-solid border-2 border-gray-400 text-gray-400;
}

#rb-app3 .step-done {
  @apply border-red-600 text-red-600;
}

#rb-app3 .step-active {
  @apply border-red-600 text-white bg-red-600;
}

span.vs__selected {
  @apply text-red-600;
}

.vs--searchable .vs__dropdown-toggle {
  @apply rounded-lg border-gray-500 focus:border-gray-800 focus:bg-gray-100;
  padding: 0.3rem 0 0.5rem;
}
</style>
